import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Col, Row, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { i18nKey } from 'src/locales/i18n';

import CorporateBorrowerContactPerson from './contact-person/contact-person';
import CorporateLevelBorrowerDocuments from './company-document/company-documents';
import CompanyDetailForm from './company-detail/company-detail';
import { ICorporateOnboardingStore } from 'src/store/corporate/onboarding.store';

import useStore from 'src/hooks/useStore';
import CorporateBorrowerOtherDetail from './other-detail/other-detail';
import { COMPANY_ONBOARDING_TYPE } from 'src/constants';

interface IProps {
	onConfirmForm?: () => void;
	isViewFullForm?: boolean;
}

const CorporateBorrowerRequestPage: FC<IProps> = ({ onConfirmForm, isViewFullForm }) => {
	const [loading, setLoading] = useState(false);

	const [t] = useTranslation();

	const onboardingStore: ICorporateOnboardingStore = useStore('corporateOnboardingStore');

	useEffect(() => {
		setLoading(true);
		onboardingStore.loadProgress(COMPANY_ONBOARDING_TYPE.BORROWER).then(() => setLoading(false));
	}, []);

	return (
		<>
			<Spin spinning={loading}>
				<CompanyDetailForm />
				<CorporateBorrowerContactPerson />
				<CorporateBorrowerOtherDetail />
				<CorporateLevelBorrowerDocuments />
				{!isViewFullForm && (
					<>
						<Row
							gutter={[
								{ xs: 0, sm: 0, md: 0, lg: 132 },
								{ xs: 20, sm: 20, md: 20, lg: 16 }
							]}
							style={{ marginTop: 30 }}>
							<Col span={24}>
								<Row gutter={16}>
									<Col span={24}>
										<Button block type="primary" loading={loading} onClick={onConfirmForm}>
											{t(i18nKey.common.submit)}
										</Button>
									</Col>
								</Row>
							</Col>
						</Row>
					</>
				)}
			</Spin>
		</>
	);
};

export default observer(CorporateBorrowerRequestPage);
